import { useApplication } from "../contexts/ApplicationContext";
import Dashboard from "./Dashboard";
import PortfolioDashboard from "./PortfolioDashboard";
import {
  SkeletonHeader,
  SkeletonKpiStrip,
  SkeletonChart,
} from "./crm/Skeletons";

/**
 * O administrador continua vendo o painel global da plataforma; o gerente de
 * contas vê o painel da própria carteira.
 */
const DashboardRouter = () => {
  const { isAdmin, isLoadingUser } = useApplication();

  // Esqueleto com a forma do painel, não um spinner solto no meio da tela:
  // o papel do usuário decide QUAL painel abre, e nesse intervalo já dá para
  // reservar o espaço do que vem.
  if (isLoadingUser) {
    return (
      <div className="space-y-4">
        <SkeletonHeader withAction={false} />
        <SkeletonKpiStrip count={4} />
        <SkeletonChart height={220} bars={12} />
      </div>
    );
  }

  return isAdmin ? <Dashboard /> : <PortfolioDashboard />;
};

export default DashboardRouter;
